import { useEffect, useState } from "react";
import { toast } from "sonner";
import { RefreshCw } from "lucide-react";
import { adminApi } from "@/lib/api";
import { DailyChart, usd } from "@/components/admin/ApifyUsageCard";

const FreeBar = ({ u }) => (
  <div>
    <div className="flex items-baseline justify-between text-xs font-mono mb-1">
      <span data-testid="places-usage-free">Gratuite usate: {u.free_used} / {u.free_quota}</span>
      <span style={{ color: u.free_pct >= 90 ? "#E3242B" : u.free_pct >= 70 ? "#f59e0b" : "#10b981" }}>{u.free_pct}%</span>
    </div>
    <div className="h-2 bg-[#e5e9eb] rounded-full overflow-hidden">
      <div className="h-full rounded-full bg-[#4285F4] transition-[width] duration-700" style={{ width: `${Math.min(100, u.free_pct)}%` }} />
    </div>
    <div className="flex justify-between text-[11px] text-[#5b6168] mt-1">
      <span>Richieste oltre le gratuite: <b>{Math.max(0, u.requests - u.free_quota)}</b></span>
      <span>Rinnovo: {u.cycle_end}</span>
    </div>
  </div>
);

export const GooglePlacesUsageCard = ({ configured }) => {
  const [u, setU] = useState(null);
  const load = () => adminApi.placesUsage().then(setU).catch(() => toast.error("Errore lettura consumo Google Places"));
  useEffect(() => { if (configured) load(); }, [configured]);
  if (!configured) return null;
  return (
    <div data-testid="places-usage-card" className="mt-3 p-4 bg-white border border-[#d5dbde] rounded-sm">
      <div className="flex items-center justify-between mb-3">
        <span className="text-xs font-semibold uppercase tracking-wider">Consumo Google Places (mese)</span>
        <button data-testid="places-usage-refresh-btn" onClick={load} className="text-[#5b6168] hover:text-[#2B3036] transition-colors">
          <RefreshCw size={14} />
        </button>
      </div>
      {!u && <p className="text-xs text-[#6b7280] font-mono">Carico…</p>}
      {u && (
        <>
          <FreeBar u={u} />
          <div className="grid md:grid-cols-2 gap-4 mt-4">
            <div className="text-[11px] font-mono space-y-1">
              <div className="flex justify-between border-b border-[#e5e9eb] pb-1"><span>Richieste</span><span data-testid="places-usage-requests">{u.requests}</span></div>
              <div className="flex justify-between border-b border-[#e5e9eb] pb-1"><span>Costo a listino</span><span data-testid="places-usage-used">{usd(u.used_usd)}</span></div>
              <div className="flex justify-between border-b border-[#e5e9eb] pb-1"><span>Tariffa</span><span>{usd(u.unit_usd)} / richiesta</span></div>
            </div>
            <DailyChart daily={u.daily} testid="places-usage-daily-chart" />
          </div>
          <p className="text-[10px] text-[#6b7280] mt-3">Costo prudente a listino pieno (Text Search Enterprise + Atmosphere): le prime {u.free_quota} richieste del mese Google non le addebita.</p>
        </>
      )}
    </div>
  );
};
